import * as Common from './init';

export default Common;